// Partes do site ligadas agora (backoffice → Site). O HTML pré-renderizado sai com os valores por omissão
// (@ecliptica/config/site-sections: hoje sem BD); no browser chegam os valores reais de /v1/public/info e o React
// mostra/esconde menu, secções e descargas — sem republicar o site. Enquanto o pedido não responde (e se falhar)
// valem os valores por omissão, iguais ao HTML: a hidratação não vê diferenças.
import { usePublicInfo } from "@ecliptica/api-client/react";
import { SITE_SECTIONS_DEFAULT, withSectionDefaults, type SiteSections } from "@ecliptica/config/site-sections";

export function useSiteSections(): SiteSections {
  const info = usePublicInfo();
  return info.data ? withSectionDefaults(info.data.siteSections) : SITE_SECTIONS_DEFAULT;
}

/** Painéis da secção "Descarregar" que fazem sentido com estas partes ligadas (vazio → a secção e o menu escondem-se). */
export function downloadPanels(on: SiteSections): ("game" | "books" | "comic")[] {
  if (!on.downloads) return [];
  return [...(on.game ? (["game"] as const) : []), ...(on.books ? (["books"] as const) : []), ...(on.comic ? (["comic"] as const) : [])];
}
